import React from "react";
import '../../CSS/Obras.css'
import { Button, CloseButton, Modal } from "react-bootstrap";

const ResumenObraProyecto = ({show, handleClose,nombre,total}) => {
    const obra = nombre;
    const totalMO = total.length === 0? 0:total[0].manoObra;
    const totalAdi = total.length === 0? 0:total[0].adicional;
    const totalMaq = total.length === 0? 0:total[0].maquinaria;
    const totalTra = total.length === 0? 0:total[0].tramites;
    const totalMat = total.length === 0? 0:total[0].materiales;

    const totalFinal = totalMO + totalAdi + totalMaq + totalTra + totalMat;
    function formato(numero){
        var num = Number.parseFloat(numero).toFixed(2)
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }
    
    const manoTotal = formato(totalMO)
    const adiTotal = formato(totalAdi)
    const maqTotal = formato(totalMaq)
    const traTotal = formato(totalTra)
    const matTotal = formato(totalMat)
    const finalTotal = formato(totalFinal)

    return (
        <Modal show={show} onHide={handleClose}  id="resumen-obra-proyecto" >
            <Modal.Header className=' btncolor'>
                <Modal.Title>EGRESOS</Modal.Title>
                <CloseButton onClick={handleClose} style={{backgroundColor:"white"}} />
            </Modal.Header>
            <Modal.Body  style={{textAlign:'right', marginTop:'15px', height:'60vh', overflowY:"scroll"}}>
                <div className="mb-3" style={{textAlign:'center'}}>
                    <h5 className="modal-title text-uppercase" id="exampleModalLabel">{obra}</h5>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">MATERIALES</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {matTotal === 0 ? (0):(matTotal)}
                            </strong>
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">MANO DE OBRA</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {manoTotal === 0 ? (0):(manoTotal)}
                            </strong>
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">ADICIONALES</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {adiTotal === 0 ? (0):(adiTotal)}
                            </strong>
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">MAQUINARIA</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {maqTotal === 0 ? (0):(maqTotal)}
                            </strong>
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">TRAMITES</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {traTotal === 0 ? (0):(traTotal)}
                            </strong>
                        </label>
                    </div>
                </div>
                <hr/>
                <div className="row">
                    <div className="col" >
                        <label htmlFor="exampleFormControlInput1" className="form-label">TOTAL</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {finalTotal === 'NaN' ? (0):(finalTotal)}
                            </strong>
                        </label>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Button type="button" className="btn btncolor" onClick={handleClose}>CERRAR</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ResumenObraProyecto;